<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading || archiveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} banner
            </h2>
            <div class="pb-0">
                <v-form name="editForm" ref="editForm">
                    <div class="tw-flex tw-mb-2 tw-p-2">
                        <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
                            <v-select
                                v-model="modelObject.carousel"
                                :items="carouselsValueList"
                                dense
                                color="primary"
                                label="Carousel"
                                display-label="Carousel"
                                :rules="[rules.required]"
                                hide-details
                                reactive
                                outlined
                                v-show="false"
                            />

                            <v-text-field
                                v-model="modelObject.priority"
                                label="Priority"
                                :rules="[rules.required, rules.unsignedInteger]"
                                hide-details
                                type="number"
                                step="10"
                            ></v-text-field>

                            <v-text-field
                                v-model="modelObject.title"
                                label="Title"
                                :rules="[rules.required]"
                                hide-details
                                clearable
                            ></v-text-field>

                            <v-file-input
                                v-model="modelObject.new_image_desktop"
                                label="Desktop image"
                                dense
                                outlined
                                hide-details
                                :prepend-icon="null"
                                :rules="!is_edit_mode ? [rules.required] : []"
                            >
                            </v-file-input>

                            <v-file-input
                                v-model="modelObject.new_image_mobile"
                                label="Mobile image"
                                dense
                                outlined
                                hide-details
                                :prepend-icon="null"
                                :rules="!is_edit_mode ? [rules.required] : []"
                            >
                            </v-file-input>

                            <v-text-field
                                v-model="modelObject.image_caption"
                                label="Image caption"
                                :rules="[rules.required]"
                                hide-details
                                clearable
                            ></v-text-field>

                            <v-select
                                v-model="modelObject.image_color"
                                :items="photoFiltersValueList"
                                dense
                                color="primary"
                                label="Photo filter"
                                :rules="[rules.required]"
                                hide-details
                                reactive
                                outlined
                            />

                        </div>
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3" >
                <v-btn
                    text
                    @click="archiveModel"
                    class="btn-solid"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditCarouselModal",
    components: {
        WYSIWYG
    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'nextPriorityProp': {
            // The next priority of the carousel
            type: Number,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: true
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: {},
            modelDefault: {
                id: null,
                carousel: this.constants.CAROUSEL_LOCATIONS.LOCATION_HOME_TOP_SECTION, // We fix this for now
                priority: null,
                title: null,
                image_desktop: null, // The current image if available
                new_image_desktop: null, // Custom field for new image to upload
                image_mobile: null, // The current image if available
                new_image_mobile: null, // Custom field for new image to upload
                image_caption: null,
                image_color: null,
            },
            saveLoading: false,
            archiveLoading: false,
            rules: {
                required: value => !!value || 'Required',
                unsignedInteger: value => value > 0 || 'Must be a positive integer',
            },

            // Custom ValueList from model constants
            carouselsValueList: [
                {text: 'Home top section',       value: this.constants.CAROUSEL_LOCATIONS.LOCATION_HOME_TOP_SECTION},
                {text: 'Home latest shows',   value: this.constants.CAROUSEL_LOCATIONS.LOCATION_HOME_LATEST_SHOWS},
            ],
            photoFiltersValueList: [
                {text: 'Normal',       value: this.constants.CAROUSEL_PHOTO_FILTERS.PHOTO_FILTER_NORMAL},
                {text: 'Blue',   value: this.constants.CAROUSEL_PHOTO_FILTERS.PHOTO_FILTER_BLUE},
                {text: 'Green',   value: this.constants.CAROUSEL_PHOTO_FILTERS.PHOTO_FILTER_GREEN},
                {text: 'Black & white',   value: this.constants.CAROUSEL_PHOTO_FILTERS.PHOTO_FILTER_BLACK_AND_WHITE},
            ],
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '450px'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        }
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            //let payload = this.modelObject

            if (this.$refs.editForm.validate()) {

                let formData = new FormData()
                formData.append("carousel", this.modelObject.carousel)
                formData.append("priority", this.modelObject.priority)
                formData.append("title", this.modelObject.title)
                formData.append("image_caption", this.modelObject.image_caption)
                formData.append("image_color", this.modelObject.image_color)

                if( this.modelObject.new_image_desktop ) {
                    formData.append("new_image_desktop", this.modelObject.new_image_desktop)
                }
                if( this.modelObject.new_image_mobile ) {
                    formData.append("new_image_mobile", this.modelObject.new_image_mobile)
                }

                var url = ''

                if( this.is_edit_mode ) {
                    url = route('carousels.update', this.modelObject.id)
                    formData.append("_method", "put")
                } else {
                    url = route('carousels.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-carousel-save')
                            this.modelObject.new_image_desktop = null
                            this.modelObject.new_image_mobile = null

                            if( !this.is_edit_mode ) {
                                // Add mode
                                this.modelDefault.priority = parseInt(this.modelObject.priority) + 10
                            }

                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveModel()
        {
            if (await this.$root.confirm.open(`Delete Image`, `You are about to delete ${this.modelObject.title}`)) {

                let method = 'delete'
                let url = route('carousels.destroy', this.modelObject.id)
                let payload = this.modelObject

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Image has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-carousel-delete')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.$refs.editForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)

                    if( this.modelDefault.priority > 0 ) {
                        this.modelObject.priority = this.modelDefault.priority
                    } else if( this.nextPriorityProp ) {
                        this.modelObject.priority = this.nextPriorityProp
                    } else {
                        this.modelObject.priority = 10
                    }

                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
        'modelProp.date'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
            }
        },
    },
}

</script>

<style scoped>

</style>
